import { formatBytes } from "helpers/utils"
import React from "react"
import { Link } from "react-router-dom"
import { Button, Card, Col, Row } from "reactstrap"
import PropTypes from "prop-types"

function PreviewFileCard(props) {
  const { file = [], onDelete } = props
  return (
    <Card
      className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
      key={file.name}
    >
      <div className="p-2 space-between flex-nowrap">
        <div className="d-flex align-items-center gap-2">
          {file.type.includes("image") ? (
            <img
              height="80"
              className="avatar-sm rounded bg-light"
              alt={file.name}
              src={URL.createObjectURL(file)}
            />
          ) : (
            <div className="avatar-sm rounded bg-primary box-center text-white h3 mb-0">
              <i className="bx bxs-file-pdf"></i>
            </div>
          )}
          <div>
            <p className="mb-0 text-muted h6 font-weight-bold">{file.name}</p>
            <p className="mb-0">
              <strong>{formatBytes(file.size)}</strong>
            </p>
          </div>
        </div>
        {onDelete ? (
          <Button size="sm" color="soft-danger" onClick={onDelete}>
            <i className="bx bx-trash"></i>
          </Button>
        ) : null}
      </div>
    </Card>
  )
}
PreviewFileCard.propTypes = {
  file: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
}
export default PreviewFileCard
